/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { Marker, GoogleMap, LoadScript } from '@react-google-maps/api';

type Props = {
  coordinates: any;
  height?: string;
  width?: string;
  resetLocation: any;
  apiKey: string;
  onMapError: (hasError: boolean) => void;
  options?: any;
};

export default function Map({
  coordinates,
  height,
  width = `100%`,
  resetLocation,
  apiKey,
  onMapError,
  options,
}: Props) {
  const [mapCenter, setMapCenter] = useState(null);
  const [markerPosition, setMarkerPosition] = useState(null);
  const googleMap = useRef(null);

  useEffect(() => {
    if (coordinates) {
      setMapCenter(coordinates);
      setMarkerPosition(coordinates);
    }
  }, [coordinates]);

  const onDrag = () => {
    resetLocation();
    setMapCenter({
      lat: googleMap.current.state.map.center.lat(),
      lng: googleMap.current.state.map.center.lng(),
    });
  };

  return (
    <LoadScript googleMapsApiKey={apiKey} onError={() => onMapError(true)}>
      <GoogleMap
        mapContainerStyle={{ width, height }}
        center={mapCenter}
        zoom={18}
        options={options}
        onDragEnd={() => onDrag()}
        ref={googleMap}
      >
        {mapCenter && <Marker position={markerPosition} />}
      </GoogleMap>
    </LoadScript>
  );
}
